function parseColor(value) {
    if (typeof value !== 'string') {
        return null
    }

    const hex = value.trim().replace(/^#/, '')
    if (/^[0-9a-f]{3}$/i.test(hex)) {
        return {
            r: parseInt(hex[0] + hex[0], 16),
            g: parseInt(hex[1] + hex[1], 16),
            b: parseInt(hex[2] + hex[2], 16),
        }
    }
    if (/^[0-9a-f]{6}$/i.test(hex)) {
        return {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16),
        }
    }

    const rgb = value.match(/rgba?\(([^)]+)\)/i)
    if (rgb) {
        const parts = rgb[1].split(',').map((p) => parseFloat(p))
        return { r: parts[0], g: parts[1], b: parts[2] }
    }

    return null
}

function luminance(color) {
    const c = parseColor(color)
    if (!c) {
        return 1
    }
    const channel = (v) => {
        const s = v / 255
        return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)
    }
    return 0.2126 * channel(c.r) + 0.7152 * channel(c.g) + 0.0722 * channel(c.b)
}

function readableInk(background) {
    return luminance(background) > 0.55 ? '#000000' : '#ffffff'
}

function rgba(color, alpha) {
    const c = parseColor(color)
    if (!c) {
        return null
    }
    return `rgba(${Math.round(c.r)}, ${Math.round(c.g)}, ${Math.round(c.b)}, ${alpha})`
}

function setVar(key, value) {
    if (value != null && value !== '') {
        document.documentElement.style.setProperty(key, String(value))
    }
}

// The app runs the Shift Arcade design system with a LIGHT and a DARK theme
// (light is the default). A whitelabel location tunes: its theme choice, its
// primary colour (the Race Red action accent), its secondary colour (the data
// accent that everything teal follows), its font, and its nav colours.
function setTheme(options = {}) {
    const { theme, primary, secondary, navBg, navColor, navLinks, navLinksHover, fontFamily, fontURL, extraCSS } = options

    const mode = String(theme || '').toUpperCase() === 'DARK' ? 'dark' : 'light'
    document.documentElement.setAttribute('data-theme', mode)

    let fontLink = document.getElementById('dynamic-theme-font')
    if (!fontLink) {
        fontLink = document.createElement('link')
        fontLink.id = 'dynamic-theme-font'
        fontLink.rel = 'stylesheet'
        document.head.appendChild(fontLink)
    }
    if (fontURL) {
        fontLink.href = fontURL
    }

    if (primary) {
        setVar('--action', primary)
        setVar('--accent', primary)
        setVar('--link', primary)
        setVar('--sos-brand', primary)
        setVar('--sos-brand-ink', readableInk(primary))
        setVar('--sos-accent', primary)
        setVar('--sos-link', primary)
        setVar('--red-300', primary)
        const glow = rgba(primary, 0.18)
        if (glow) {
            setVar('--sh-red', `0 0 0 1px ${rgba(primary, 0.4)}, 0 8px 30px ${glow}`)
        }
        const actionSoft = rgba(primary, 0.1)
        const actionLine = rgba(primary, 0.32)
        if (actionSoft) {
            setVar('--action-soft', actionSoft)
        }
        if (actionLine) {
            setVar('--action-line', actionLine)
        }
    }
    if (secondary) {
        setVar('--teal', secondary)
        setVar('--data', secondary)
        setVar('--kicker', secondary)
        setVar('--focus', secondary)
        setVar('--teal-300', secondary)
        setVar('--teal-500', secondary)
        setVar('--teal-ink', readableInk(secondary))
        setVar('--sos-teal', secondary)
        setVar('--sos-teal-ink', secondary)
        setVar('--pm-chase', secondary)
        const soft = rgba(secondary, 0.22)
        const line = rgba(secondary, 0.32)
        if (soft) {
            setVar('--focus-ring', soft)
            setVar('--sos-teal-soft', soft)
            setVar('--sos-accent-soft', soft)
        }
        if (line) {
            setVar('--sos-teal-line', line)
        }
    }
    if (fontFamily) {
        setVar('--font-body', fontFamily)
        setVar('--sos-font', fontFamily)
    }

    if (navBg) {
        setVar('--nav-bg', navBg)
    }
    if (navLinks) {
        setVar('--nav-link', navLinks)
    }
    if (navLinksHover) {
        setVar('--nav-link-hover', navLinksHover)
    }
    if (navColor && !navLinks) {
        setVar('--nav-link', navColor)
    }

    let extraStyle = document.getElementById('dynamic-extra-css')
    if (!extraStyle) {
        extraStyle = document.createElement('style')
        extraStyle.id = 'dynamic-extra-css'
        document.head.appendChild(extraStyle)
    }
    extraStyle.innerHTML = extraCSS || ''
}

const Branding = {
    install(app, options) {
        const { store } = options
        app.prototype.$branding = {
            setTheme,
            storeVal(variable, defaultValue) {
                const value = store.state.branding[variable]

                if ('undefined' !== typeof value) {
                    return value
                }

                return defaultValue
            },
        }
    },
}

export default Branding
